import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import Swal from 'sweetalert2';
declare var $:any;


@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss']
})
export class DeleteAccountComponent { 

  public loading:boolean = false;
  public submitted:boolean = false;
  selectedFile:any;
  public rememberCheck : boolean = false ;
  public email : any ;
  public password : any;

  loginData = new FormGroup({
    email:new FormControl('',Validators.compose([
      Validators.required, Validators.email  ])),
    password:new FormControl('',Validators.compose([
      Validators.required,Validators.minLength(6),
      Validators.maxLength(30) ,
      // Validators.pattern('[a-zA-Z0-9\s]{6,30}') 
    ])),
  })
  
   get f() { return this.loginData.controls; }

  constructor(public router: Router, public service: GlobalService) {
   }

   Onsubmit(){
    this.loading=true;
    this.submitted = true;    
    let userdetail = this.loginData;
    if(userdetail.valid){
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      }).then((result:any) => {
        let statusType: number = 0;
        if (result.isConfirmed) {
          this.loading=true;
          var detail={"email": (userdetail.value.email)?.toLowerCase(),"password": userdetail.value.password};
          this.service.PostApis(detail,'/delete').subscribe(((response:any)=>{
          if(response.success){
            this.loading=false;
            this.service.successAlert(response.message);
            this.loginData.reset();
            this.submitted = false;  
          } else {
            this.service.dangerAlert(response.message);
            this.loading=false;
          }
        }))
        }
      });     
  } else{
    window.scroll(0,0);
  }
  }

  showHide(str: any) {
    var input = $($(str).attr("toggle"));
    if (input.attr("type") == "password") {
      input.attr("type", "text");
      $(str).removeClass("bx bx-low-vision");
      $(str).addClass("bx bx-show ");
    } else {
      input.attr("type", "password");
      $(str).removeClass("bx bx-show ");
      $(str).addClass("bx bx-low-vision");
    }
  }

}
